"use client";

import React, { createRef } from "react";
import StylesNSBox from "./NSBox.module.css";
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { IValidationProps } from "../props/IValidationProps";
import { IValidationStringProps } from "../props/IValidationStringProps";
import { Validator } from "../Validator";
import { safeMenuMenuItem } from "./NSMenuButton";
import { INSBoxBaseLayoutProps, NSBoxBaseLayout } from "./NSBoxBaseLayout";
import { INSBox } from "./INSBox";

export interface NSBoxFontProps extends IBaseComponentProps, IValidationProps, IValidationStringProps, INSBoxBaseLayoutProps<NSBoxFont, string>
{
	input?: IBaseComponentProps;
}

export interface NSBoxFontState
{
	value: string | null;
}

export class NSBoxFont extends React.Component<NSBoxFontProps, NSBoxFontState> implements INSBox
{
	NSBoxBaseLayout_Main = createRef<NSBoxBaseLayout>();
	constructor(props: NSBoxFontProps)
	{
		super(props);
		this.state = { value: props.defaultValue ?? null };
		this.isEmpty = this.isEmpty.bind(this);
		this.getError = this.getError.bind(this);
		this.getValue = this.getValue.bind(this);
		this.setValue = this.setValue.bind(this);
	}
	isEmpty(value: string)
	{
		if ((value ?? "").trim())
			return false;
		return true;
	}
	getError(): string | null
	{
		return (
			Validator.getError(this.props.title, this.state.value, this.props) ||
			Validator.getErrorString(this.props.title, this.state.value, this.props)
		);
	}
	getValue(checkError: boolean = true): string | null
	{
		return NSBoxBaseLayout.checkGetValue(this, checkError, () => this.state.value);
	}
	setValue(value: string | null, callback?: () => void): void
	{
		this.setState({ value }, () =>
		{
			this.props.onChanged?.(this);
			callback?.();
		});
	}
	override render()
	{
		let menu = safeMenuMenuItem(this.props, () => { });
		menu.builtin.copy = { enabled: true, getValue: () => this.state.value ?? "" };

		return (
			<NSBoxBaseLayout
				ref={this.NSBoxBaseLayout_Main}
				{...this.props}
				menu={menu}
			>
				<div
					id={this.props.input?.id}
					// name={this.props.input?.name}
					// type="text"
					className={`${StylesNSBox.ns_box_input} ${this.props.input?.classList?.join(" ") ?? ""}`}
					// placeholder={this.props.placeholder ?? `Please enter ${NamingConvention.auto.convert(this.props.title, NamingConvention.lower_case_space)}`}
					// value={this.state.value ?? ""}
					// onChange={e => this.setValue(e.target.value)}
					// onClick={() => { this.props.onClicked?.(this); }}
					style={{
						background: `url("https://static.namirasoft.com/image/concept/type/font.png") white no-repeat scroll center right 4px`,
						backgroundSize: "24px",
						...this.props.input?.style,
						lineHeight: "48px",
						display: "flex",
						padding: "0px",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					Not implemented
				</div>
			</NSBoxBaseLayout>
		);
	}
}